/* eslint-disable no-unused-vars */
import Swiper from 'swiper/swiper-bundle';

const logosCarousel = () => {
    const carousels = document.getElementsByClassName('logos__itemsWrapper');
    if (!carousels.length) return;

    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('logos__items--carousel')[0];
        slider.setAttribute('id', `logos__items--carousel-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('swiper-pagination')[0];
        pagination.classList.add(`swiper-pagination-${i}`);
        // add unique class to each next button
        const nextButton = carousel.getElementsByClassName('swiper-button-next')[0];
        nextButton.classList.add(`swiper-button-next-${i}`);
        // add unique class to each prev button
        const prevButton = carousel.getElementsByClassName('swiper-button-prev')[0];
        prevButton.classList.add(`swiper-button-prev-${i}`);

        // eslint-disable-next-line no-unused-vars
        const swiper = new Swiper(`#logos__items--carousel-${i}`, {
            // Optional parameters
            slidesPerView: 2,
            slidesPerGroup: 2,
            loop: true,
            spaceBetween: 30,
            grabCursor: true,
            watchOverflow: true,
            loopFillGroupWithBlank: true,
            // centeredSlides: true,
            // If we need pagination
            pagination: {
                el: `.logos__itemsWrapper .swiper-pagination-${i}`,
                clickable: true
            },
            // Navigation arrows
            navigation: {
                nextEl: `.logos__itemsWrapper button.swiper-button-next-${i}`,
                prevEl: `.logos__itemsWrapper button.swiper-button-prev-${i}`,
            },
            breakpoints: {
                // when window width is >= 480px
                480: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    loop: true,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    loop: true,
                },
                // when window width is >= 920px
                920: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    loop: true,
                },
                // when window width is >= 1200x
                1200: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                    loop: true,
                }
            }
        });
    }
};

const testimonialsCarousel = () => {
    const carousels = document.getElementsByClassName('testimonials__carouselWrapper');
    if (!carousels.length) return;


    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('testimonials__carousel')[0];
        slider.setAttribute('id', `testimonials__carousel-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('swiper-pagination')[0];
        pagination.classList.add(`swiper-pagination-${i}`);
        // add unique class to each next button
        const nextButton = carousel.getElementsByClassName('swiper-button-next')[0];
        nextButton.classList.add(`swiper-button-next-${i}`);
        // add unique class to each prev button
        const prevButton = carousel.getElementsByClassName('swiper-button-prev')[0];
        prevButton.classList.add(`swiper-button-prev-${i}`);

        const testimonialsCarouselSwiper = new Swiper(`#testimonials__carousel-${i}`, {
            // Optional parameters
            slidesPerView: 1,
            // loop: true,
            grabCursor: true,
            effect: 'fade',
            watchOverflow: true,
            fadeEffect: {
                crossFade: true,
            },
            // If we need pagination
            pagination: {
                el: `.testimonials__carouselWrapper .swiper-pagination-${i}`,
                clickable: true
            },
            // Navigation arrows
            navigation: {
                nextEl: `.testimonials__carouselWrapper button.swiper-button-next-${i}`,
                prevEl: `.testimonials__carouselWrapper button.swiper-button-prev-${i}`,
            },
        });
    }

};


/**
 * Function to run when this module is called from site.js
 */
const init = () => {

    testimonialsCarousel();
    logosCarousel();

};

export default init;
